const appId = 'apa_mdfn4ee576';
const redirectUrl = 'https://stageapi.wix.exportfeed.com/auth/faire/redirect';

const FaireConfig = {
    backendApiBaseUrl: 'https://stageapi.wix.exportfeed.com',
    authorizationUrl: `https://faire.com/oauth2/authorize?applicationId=${appId}&scope=READ_PRODUCTS&scope=WRITE_PRODUCTS&scope=READ_ORDERS&scope=WRITE_ORDERS&scope=READ_BRAND&scope=READ_RETAILER&scope=READ_INVENTORIES&scope=WRITE_INVENTORIES&scope=READ_SHIPMENTS&redirectUrl=${redirectUrl}`
}

export default FaireConfig;